import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import EventAttendanceIcon from '../icon/eventAttendanceIcon';
import IncomingEventsPanel from './IncomingEventsPanel';
import './IncomingEventsNavPopup.css';

/**
 * Navbar Incoming events control (icon + label) that opens Attend Events
 * listings in a near-full-page modal. Portaled to document.body so sticky
 * header backdrop-filter does not clip it.
 */
const IncomingEventsNavPopup = ({ user = null }) => {
  const [open, setOpen] = useState(false);
  const isLoggedIn = Boolean(user?.id);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const modal =
    open &&
    createPortal(
      <div
        className="events-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="incoming-events-modal-title"
        onClick={() => setOpen(false)}
      >
        <div className="events-modal" onClick={(e) => e.stopPropagation()}>
          <div className="events-modal-header">
            <div className="events-modal-header-copy">
              <span className="events-modal-kicker">Community RSVP</span>
              <h2 id="incoming-events-modal-title" className="events-modal-header-title">
                Incoming events
              </h2>
              <p className="events-modal-subtitle">
                {isLoggedIn
                  ? 'RSVP to community events and save them to Google, Outlook, or Yahoo Calendar.'
                  : 'Browse upcoming events you can attend. Log in to RSVP and add them to your calendar.'}
              </p>
            </div>
            <button
              type="button"
              className="events-modal-close"
              onClick={() => setOpen(false)}
              aria-label="Close incoming events"
            >
              <X size={18} strokeWidth={2.25} />
            </button>
          </div>
          <div className="events-modal-body">
            <IncomingEventsPanel user={user} onNavigate={() => setOpen(false)} />
          </div>
        </div>
      </div>,
      document.body
    );

  return (
    <>
      <button
        type="button"
        className={`events-nav-btn${open ? ' is-open' : ''}`}
        onClick={() => setOpen(true)}
        aria-label="Open incoming events"
        title="Incoming events"
      >
        <EventAttendanceIcon size="16px" />
        <span className="events-nav-btn-label">Incoming events</span>
      </button>
      {modal}
    </>
  );
};

export default IncomingEventsNavPopup;
